import { apiGet } from '@/api/api.ts'
import { useQuery, keepPreviousData } from '@tanstack/react-query'
import { QueryCacheKeys } from '@/api/queryKeys.ts'
import { createUrl } from '@/util/url.ts'
import { MINUTE } from '@/constant/time.ts'
import { AlertStatus, DeviceStatus } from '@/api/user/getUsers.ts'
import { IPagingReq, IPagingRes } from '@/api/paging.ts'

interface IReqGetUsersStatusList extends IPagingReq {
    pageNum: number
    pageSize: number
}

// 회원 관리 목록 카드가 쓰는 값만 담은 한 줄. 연락처·주소·위치는 내려오지 않는다.
export interface IUserStatusListItem {
    id: number
    name: string
    gender: number | null
    birthDate: string | null
    alertStatus: AlertStatus
    device: IUserStatusListDevice | null
}

export interface IUserStatusListDevice {
    id: number
    status: DeviceStatus
    battery: number | null
}

export const apiGetUsersStatusList = async (params: IReqGetUsersStatusList, query?: string) => {
    return await apiGet<IPagingRes<IUserStatusListItem>>(
        createUrl(`/protectee/status-list`, {
            pageNum: params.pageNum,
            pageSize: params.pageSize,
            query
        })
    )
}

const useQueryGetUsersStatusList = (params: IReqGetUsersStatusList, query?: string) => {
    return useQuery({
        queryKey: [...QueryCacheKeys.user.getUsersStatusList(query), params.pageNum, params.pageSize],
        refetchInterval: 1 * MINUTE,
        queryFn: async () => {
            const { data } = await apiGetUsersStatusList(params, query)
            return data
        },
        placeholderData: keepPreviousData
    })
}

export default useQueryGetUsersStatusList
